/**
 * 创建人：但志强
 * 时间：2019-3-29
 * 描述：消息提示
 * 更新记录: 
 */
import { Injectable, Injector, ApplicationRef, ComponentFactoryResolver} from "@angular/core";
import { SwModalComponent } from './sw-modal.component';
import { SwNoticeComponent } from './sw-notice.component';
import { SwDestructionService } from "src/app/librarys/serves/sw-destruction.service";

@Injectable()
export class SwMessageService {
    constructor(
        private injector: Injector,
        private applicationRef: ApplicationRef,
        private componentFactoryResolver: ComponentFactoryResolver,
        private SwDestructionService:SwDestructionService ///注入销毁组件的服务
        ){}

    //提醒框
    showAlert(message: string, type: string){ 
        //创建节点
        const rootpop = document.createElement("sw-alert");
        
        const factory = this.componentFactoryResolver.resolveComponentFactory(SwNoticeComponent);
        const componentRef = factory.create(this.injector, [], rootpop);
        this.applicationRef.attachView(componentRef.hostView);

        //组件内部事件触发
        componentRef.instance.voted.subscribe(()=>{   
             document.body.removeChild(rootpop);
             //销毁组件
             this.applicationRef.detachView(componentRef.hostView);
             componentRef.destroy()
        });
        //往组件内传参
        componentRef.instance.message = message;
        componentRef.instance.type = type;
        //添加至根节点
        document.body.appendChild(rootpop);
    }

    //需要确认或取消的提示框
    showModal(message: string, type: string, callback?:any){ 
        this.SwDestructionService.destruction("sw-modal");///销毁之前的组件
        const rootpop = document.createElement("sw-modal");
        const factory = this.componentFactoryResolver.resolveComponentFactory(SwModalComponent);
        const componentRef = factory.create(this.injector, [], rootpop);
        this.applicationRef.attachView(componentRef.hostView);

        componentRef.instance.voted.subscribe((data)=>{
            if(data && callback){
                callback()
            }
             document.body.removeChild(rootpop);
             this.applicationRef.detachView(componentRef.hostView);
             componentRef.destroy()
        });
        componentRef.instance.message = message;
        componentRef.instance.type = type;
        document.body.appendChild(rootpop);
    }
}

  

